import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Text — paragraph (or inline `<span>`) with optional muted styling.
 *
 * @example
 *   <Text>Default body copy.</Text>
 *   <Text muted>Smaller secondary text.</Text>
 *   <Text inline>Inline run</Text> of body text.
 */
export function Text({ inline = false, muted = false, className, children, ...rest }) {
    const Tag = inline ? 'span' : 'p';
    const classes = ['osd-text', muted ? 'osd-text--muted' : null, className]
        .filter(Boolean)
        .join(' ');
    return (_jsx(Tag, { className: classes, ...rest, children: children }));
}
//# sourceMappingURL=Text.js.map